import React from 'react'

const Door = ({ className = '' }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 11C9.224 11 9 10.552 9 10C9 9.448 9.224 9 9.5 9C9.776 9 10 9.448 10 10C10 10.552 9.776 11 9.5 11Z"
        fill="#151F31"
      />
      <path
        d="M11.828 1.12202C11.8821 1.16903 11.9254 1.2271 11.9551 1.29232C11.9848 1.35754 12.0001 1.42837 12 1.50002V2.00002H12.5C12.8978 2.00002 13.2794 2.15806 13.5607 2.43936C13.842 2.72066 14 3.10219 14 3.50002V16H15.5C15.6326 16 15.7598 16.0527 15.8536 16.1464C15.9473 16.2402 16 16.3674 16 16.5C16 16.6326 15.9473 16.7598 15.8536 16.8536C15.7598 16.9473 15.6326 17 15.5 17H2.5C2.36739 17 2.24021 16.9473 2.14645 16.8536C2.05268 16.7598 2 16.6326 2 16.5C2 16.3674 2.05268 16.2402 2.14645 16.1464C2.24021 16.0527 2.36739 16 2.5 16H4V2.50002C4.00002 2.37955 4.04353 2.26314 4.12253 2.1722C4.20154 2.08125 4.31072 2.02189 4.43 2.00502L11.43 1.00502C11.5008 0.994904 11.573 1.00011 11.6417 1.0203C11.7104 1.04048 11.7739 1.07517 11.828 1.12202ZM12.5 3.00002H12V16H13V3.50002C13 3.36741 12.9473 3.24023 12.8536 3.14647C12.7598 3.0527 12.6326 3.00002 12.5 3.00002ZM5 2.93402V16H11V2.07702L5 2.93402Z"
        fill="#151F31"
      />
    </svg>
  )
}

export default Door
